<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm2"></a></p>
<div class="fmhT sgc-1">
    come sweetly
  </div>
<div class="ctag1">
    It starts<br/>
    The way
  </div>
<div>
     <br/>
</div>
<div class="ctag1">
    It ends—<br/>
    Fingers of
  </div>
<div>
     <br/>
</div>
<div class="ctag1">
    Impossible light<br/>
    Crawling
  </div>
<div>
     <br/>
</div>
<div class="ctag1">
    Over your<br/>
    Face. In
  </div>
<div>
     <br/>
</div>
<div class="ctag1">
    Between—mind-<br/>
    Less waiting.
  </div>
<div>
     <br/>
</div>
<div class="ctag1">
    Mouth gunk<br/>
    Or a gunked
  </div>
<div>
     <br/>
</div>
<div class="ctag1">
    Up heart—<br/>
    Going is just
  </div>
<div>
     <br/>
</div>
<div class="ctag1">
    Climbing<br/>
    Back inside.
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alex_9781571318060_oeb_fm2_r1.vue?7ea78c9c